import { Action, createReducer, on } from '@ngrx/store';

import {
  initialState,
  EntityLocalidadesIDEState,
  entityLocalidadesIDEAdapter
} from './entity-localidades-ide.state';
import {
  entityLocalidadesIDELoadFailure,
  entityLocalidadesIDELoadRequest,
  entityLocalidadesIDELoadSuccess
} from './entity-localidades-ide.actions';

const reducer = createReducer(
  initialState,
  // load
  on(entityLocalidadesIDELoadRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityLocalidadesIDELoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityLocalidadesIDELoadSuccess, (state, { items }) =>
    entityLocalidadesIDEAdapter.upsertMany(items, {
      ...state,
      isLoading: false,
      error: null
    })
  )
);

export function localidadesIDEReducer(
  state: EntityLocalidadesIDEState | undefined,
  action: Action
) {
  return reducer(state, action);
}
